import { createSelector } from 'reselect'; 

const coursesWithSubject = state =>  state.coursesInfo && state.coursesInfo.response && state.coursesInfo.response.subjects;
const courseInfo = state => state.lessonPlanner && state.lessonPlanner.response && state.lessonPlanner.response.courses || {};
const lessonPlanner = state => state.courseMaterial && state.courseMaterial.response && state.courseMaterial.response.lesson_planner


export const coursesFromAllSubjectsData = createSelector(
    coursesWithSubject,
    data => {
        let _courses = [];
        data && data.length && data.forEach(sub => {
            
            if(sub.courses && sub.courses.length) {
                sub.courses && sub.courses.length && sub.courses.forEach(cou => {
                    _courses = [..._courses, cou]
                })
              // _courses = [..._courses, sub.courses]
            } 
            
        })        
        // console.log(_courses, "_courses")
        return _courses;       
    } 
)

export const lessonPlannerInfo = createSelector(
    courseInfo,
    course => {       
        const isUserPaid = !!(course && course.is_user_paid && course.is_user_paid[0]);
        const facultyInfo = course.faculty;
        const lessonPlanners = course.lesson_planners;
        const courseInfo = course;
        const isFree = !(course.actual_price > 0) || (course.is_discounted && !(course.discount_price > 0))
        return {
            isUserPaid,
            facultyInfo,
            lessonPlanners,
            courseInfo,
            isFree
        }
    }
)

export const courseMaterials = createSelector(
    lessonPlanner,
    data => {        
        const {course = {}, materials = []} = data || {};
        const isUserPaid = !!(course.is_user_paid && course.is_user_paid[0]);                
        const isFree = !(course.actual_price > 0) || (course.is_discounted && !(course.discount_price > 0))
        return {
            isUserPaid,           
            isFree,
            materials
        }
    }
)

